<script setup lang="ts">
import { computed } from 'vue';
import PatientGroupIcon from './PatientGroupIcon.vue';
import Tooltip from './Tooltip.vue';

const props = defineProps<{
  group?: 'children' | 'adults' | null;
}>();

const tooltipText = computed(() => {
  if (!props.group) {
    return '';
  }

  const i18n = window.MedfileBookingWidgetConfig?.i18n ?? {};

  if (props.group === 'children') {
    return i18n.patientGroupTooltipChildren ?? 'Pracuje z dziećmi';
  }

  return i18n.patientGroupTooltipAdults ?? 'Pracuje z dorosłymi';
});
</script>

<template>
  <Tooltip v-if="group" :text="tooltipText">
    <span class="mbw-patient-group-badge" tabindex="0">
      <PatientGroupIcon :group="group" />
    </span>
  </Tooltip>
</template>
